const helperServiceTextNumber = {
	/**
	 * @author Jared
	 * @description Convert string to capitalize, make first letter caps
	 *
	 * @param {String} string - The string to replace first small letter to capital letter
	 *
	 * @return {String} - The formatted string
	 */
	capitalize: string => {
		if (!string) return

		const words = string.trim().split(' ')

		return words.map((word) => {
			return word[0].toUpperCase() + word.substring(1)
		}).join(' ')
	},
	/**
	 * @author Jared
	 * @description  Returns a floating point number with 2 digit after point
	 *
	 * @param {Number} number - Parses a string or number and returns a floating point number
	 *
	 * @return {Float} - Floating number with 2 digit
	 */
	smartNumber: number => {
		if (!number) return
		return Number.parseFloat(number.toFixed(2)).toLocaleString('en-US')
	},
	/**
	 * @author Jared
	 * @description  Returns a number with count type like B = Billion, M = Million
	 *
	 * @param {Number} iniitialNumber - take one parameter of number type
	 *
	 * @return {Number} - Formatted Number
	 */
	shortNumber: iniitialNumber => {
		let number = iniitialNumber

		if (!number) return 'None'
		if (number >= 1000000000) number = `${Math.round(number / 1000000000)}B`
		if (number >= 1000000) number = `${Math.round(number / 1000000)}M`
		if (number > 2000) number = `${Math.round(number / 1000)}K`
		if (number > 1000) number = `${Math.round(number / 10) / 100}K`
		if (number >= 100) number = number.toFixed(1)
		if (number < 100) number = number.toFixed(1)
		number = number.replace('.0', '')
		return number
	},
	/**
	 * @author Prashant
	 * @description  Formats a number with suffixes (B, M, K) for billions, millions, and thousands, respectively, using Math.floor for rounding.
	 *
	 * @param {Number} iniitialNumber - take one parameter of number type
	 *
	 * @return {Number} - Formatted Number
	 */
	shortFollowerNumber: iniitialNumber => {
		let number = iniitialNumber

		if (!number) return 'None'
		if (number >= 1000000000) {
			number = `${Math.floor(number / 1000000000)}B`
		} else if (number >= 1000000) {
			number = `${Math.floor(number / 1000000)}M`
		} else if (number > 2000) {
			number = `${Math.floor(number / 1000)}K`
		} else if (number > 1000) {
			number = `${(number / 1000).toFixed(2)}K`
		} else {
			number = number.toFixed(1)
		}

		number = number.replace('.0', '')
		return number
	},
	/**
	 * @author Jared
	 * @description Replaces New Lines with HTML line-breaks
	 *
	 * @param {String} string - The string to replace lines with breaks
	 *
	 * @return {String} - The formatted string
	 */
	nl2br: string => {
		return string === null ? '' : string.replace(/(\r\n|\n\r|\r|\n)/g, '<br />')
	},
	formatDateToMMDDYY: (date) => {
		const formattedDate = new Date(date)
		return `${String(formattedDate.getMonth() + 1).padStart(2, '0')}/${String(formattedDate.getDate()).padStart(2, '0')}/${formattedDate.getFullYear()}`
	},
	formatDateToDDMonthYY: (date) => {
		const options = { day: 'numeric', month: 'short', year: '2-digit' }
		return new Date(date).toLocaleDateString(undefined, options)
	},
	/**
	 * @author Jared
	 * @description Return an array with unique values
	 *
	 * @param {Array} array - The array to get new array with unique values
	 * @param {String} [property] - The property to get unique values
	 *
	 * @return {Array} - The Filtered array
	 */
	uniqueArray: (array, property) => {
		if (!array)
			return array
		if (!property)
			return array.filter((item, index) => array.indexOf(item) === index) || []
		else
			return array.filter((item, index) => array.map(item => item[property]).indexOf(item[property]) === index) || []
	},
	/**
	 * @author Jared
	 * @description Shuffle an Array
	 */
	shuffleArray: ([...arr]) => {
		let m = arr.length
		while (m) {
			const i = Math.floor(Math.random() * m--);
			[arr[m], arr[i]] = [arr[i], arr[m]]
		}
		return arr
	}
}

export default helperServiceTextNumber
